// react core
import { useContext, useState, useEffect, useCallback, Fragment } from "react";

// date handling
import dayjs from "dayjs";

// material tabs
import PropTypes from "prop-types";
import Tabs from "@mui/material/Tabs";
import Tab from "@mui/material/Tab";

// material accordion
// import Accordion from "@mui/material/Accordion";
// import AccordionDetails from "@mui/material/AccordionDetails";
// import AccordionSummary from "@mui/material/AccordionSummary";
// import ExpandMoreIcon from "@mui/icons-material/ExpandMore";

// material design
import Box from "@mui/material/Box";
import Grow from "@mui/material/Grow";
// import Zoom from "@mui/material/Zoom";
// import Fade from "@mui/material/Fade";
// import Divider from "@mui/material/Divider";
import TextField from "@mui/material/TextField";
import Drawer from "@mui/material/Drawer";
import Container from "@mui/material/Container";
import Typography from "@mui/material/Typography";

// fonts icons and colors
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faAtomAlt as iconEventuators } from "@fortawesome/pro-thin-svg-icons";
import { faWrench as iconEdit } from "@fortawesome/pro-thin-svg-icons";
import { faPlus as iconNewRunner } from "@fortawesome/pro-thin-svg-icons";
import { faPortalEnter as iconNewRider } from "@fortawesome/pro-thin-svg-icons";
import { faArchive as iconArchived } from "@fortawesome/pro-thin-svg-icons";
import { faMoneyBillTrendUp as iconFinancials } from "@fortawesome/pro-duotone-svg-icons";
import { faEllipsisV as iconDropMenu } from "@fortawesome/pro-solid-svg-icons";
import { faSearch as iconTabSearch } from "@fortawesome/pro-thin-svg-icons";
import { faPlus as iconTabCreate } from "@fortawesome/pro-thin-svg-icons";
import { faList as iconTabList } from "@fortawesome/pro-thin-svg-icons";
import { faMessagesQuestion as iconContact } from "@fortawesome/pro-thin-svg-icons";
import { faInfoCircle as iconInfo } from "@fortawesome/pro-solid-svg-icons";
import { faClose as iconClose } from "@fortawesome/pro-thin-svg-icons";
import { faPortalEnter as iconJoinByLink } from "@fortawesome/pro-thin-svg-icons";
import { faBlueberries as iconCreateByActivity } from "@fortawesome/pro-thin-svg-icons";
import { faLocationPlus as iconCreateByPlace } from "@fortawesome/pro-thin-svg-icons";
import { faMagicWandSparkles as iconCustomCreate } from "@fortawesome/pro-thin-svg-icons";
import { faTowerBroadcast as iconSignalArea } from "@fortawesome/pro-solid-svg-icons";
import { faBan as iconDisabled } from "@fortawesome/pro-solid-svg-icons";
import { faExternalLink as iconExternalLink } from "@fortawesome/pro-duotone-svg-icons";

// import { faEyeSlash as iconHide } from "@fortawesome/pro-duotone-svg-icons";
// import { faEye as iconShow } from "@fortawesome/pro-duotone-svg-icons";
// import { faExclamationTriangle as iconWarning } from "@fortawesome/pro-solid-svg-icons";
// import { faLightbulb as iconInspiration } from "@fortawesome/pro-thin-svg-icons";
// import { faSearch as iconSearch } from "@fortawesome/pro-regular-svg-icons";
// import { faHandBackPointUp as iconPoint } from "@fortawesome/pro-thin-svg-icons";
// import { faSignIn as iconConnect } from "@fortawesome/pro-thin-svg-icons";
// import { faCog as iconManage } from "@fortawesome/pro-thin-svg-icons";
// import { faStream as iconEditLayer } from "@fortawesome/pro-thin-svg-icons";
// import { faAtomAlt as iconNewRunnerLayer } from "@fortawesome/pro-thin-svg-icons";
// import { faAtomAlt as iconNewRiderLayer } from "@fortawesome/pro-thin-svg-icons";
// import { faExplosion as iconNew } from "@fortawesome/pro-duotone-svg-icons";
// import { blueGrey } from "@mui/material/colors/";

// entzy config and components
import configEntzy from "components/config/ConfigEntzy";
import InputForm from "components/input/InputForm";
// import WidgetHomeMenu from "components/event/widgets/WidgetHomeMenu";
import MainCallbackLoader from "components/main/MainCallbackLoader";
import MainModule from "components/main/MainModule";
import Hero from "components/utils/custom/CustomHero";

// entzy assets
import imageHeroEvents from "assets/heros/events-dining.png";

// entzy context and services
import { MainContext } from "components/main/MainContext";
import { EventContext } from "components/event/EventContext";
import { ActionLoader } from "components/utils/common/CommonLoaders";
import {
  BigButton,
  ActionBoxButton,
  EventButton,
  MoreButton,
} from "components/utils/common/CommonButtons";
import {
  HeaderMenuTag,
  ModuleHeaderTag,
  ModuleSubHeaderTag,
  TextTag,
} from "components/utils/common/CommonTags";
import {
  idGenerator,
  idTimeGenerator,
  scrollSnapTop,
  parseEntzyLinkToDataUrl,
} from "models/Tools";
import { APP_MENU_TREE } from "models/Structure";

function EventList(props) {
  const user = props.user;
  const navigate = props.navigate;

  const moduleId = "eventuators";
  const moduleInfo = APP_MENU_TREE.find((m) => m.id === moduleId);
  const counterExcludeActivityCategories = ["activity:eventuate"];

  const mainContext = useContext(MainContext);
  const eventContext = useContext(EventContext);

  // set meet categories from event context constants sorted by category.id
  const meetCategories =
    eventContext.state.constants.meetCategories &&
    eventContext.state.constants.meetCategories.length > 0
      ? [...eventContext.state.constants.meetCategories].sort((a, b) =>
          a.id.localeCompare(b.id),
        )
      : [];

  const [loading, setLoading] = useState(false);
  const [loadingMore, setLoadingMore] = useState(false);
  const [archiving, setArchiving] = useState(null);
  const [showInfo, setShowInfo] = useState(false);
  const [showJoinForm, setShowJoinForm] = useState(false);
  const [showJoinByLink, setShowJoinByLink] = useState(false);
  const [showCreateOptions, setShowCreateOptions] = useState(false);
  const [showCreateForm, setShowCreateForm] = useState(false);
  const [showCreateByActivity, setShowCreateByActivity] = useState(true);
  const [showCreateByPlace, setShowCreateByPlace] = useState(false);
  const [stageCategory, setStageCategory] = useState(null);

  // const [mainTab, setMainTab] = useState(
  //   !isNaN(mainContext.state.viewer.trail.joinTab)
  //     ? mainContext.state.viewer.trail.joinTab
  //     : 0
  // );
  // const [tab, setTab] = useState(
  //   !isNaN(mainContext.state.viewer.trail.joinSubTab)
  //     ? mainContext.state.viewer.trail.joinSubTab
  //     : 0
  // );

  // component functions
  const isEventArchived = (event) => {
    return event.SubCategory && event.SubCategory.includes("archived");
  };
  const isViewerEventOwner = (event) => {
    return event.SubCategory && event.SubCategory.includes("owner");
  };
  const isViewerEventManager = (event) => {
    return event.SubCategory && event.SubCategory.includes("manage");
  };

  const handleLoading = (value) => {
    setLoading(value);
  };

  const handleMainTab = (event, newMainTab) => {
    mainContext.updateViewerTrail({
      joinTab: newMainTab,
    });
  };
  const handleSubTab = (event, newSubTab) => {
    mainContext.updateViewerTrail({
      joinSubTab: newSubTab,
    });
  };

  const handleCreateCallback = async (data, fastCreate) => {
    const eventName = data
      .filter((obj) => obj.id === "event-name")[0]
      .value.toLowerCase();
    const eventCountry = data.filter((obj) => obj.id === "event-country")[0]
      .value;
    const eventCurrency = data.filter((obj) => obj.id === "event-currency")[0]
      .value;

    // optional fields
    let eventTagline = data.filter((obj) => obj.id === "event-tagline");
    eventTagline =
      eventTagline && eventTagline.length ? eventTagline[0].value : "";
    let eventDetails = data.filter((obj) => obj.id === "event-details");
    eventDetails =
      eventDetails && eventDetails.length ? eventDetails[0].value : "";

    if (eventName && eventName.length && eventCountry && eventCurrency) {
      if (fastCreate) {
        handleLoading(true);
      }
      const eventContent = await eventContext.prepareCreateEvent({
        name: eventName,
        country: eventCountry.code.short,
        currency: eventCurrency.code.long,
        tagline: eventTagline,
        details: eventDetails,
      });
      if (eventContent.alert) {
        handleLoading(false);
        return {
          alert: true,
          message: eventContent.message,
        };
      } else {
        handleLoading(true);
        const element = document.getElementById("anchor-main-app");
        if (element) {
          eventContext.state.toolbox.scrollIntoViewIfNeeded(element, true);
        }
        const startData = await eventContext.prepareStartEvent(
          eventContent.data,
        );
        const startPayload = {
          startEvent: true,
          params: [eventContent, startData, "create"],
        };
        // update main context for change in event list and to track source info
        // mainContext.pullViewerEvents({ data: eventContent.data, more: true });
        mainContext.addEvent(eventContent.data, true, true);
        mainContext.updateViewerTrail({
          menuSourcePage: "eventuators",
        });
        mainContext.selectMenu("e");
        // navigate to event runner page with start callback payload
        navigate(eventContent.urlComponents.relative, {
          state: startPayload,
        });
        return { alert: false, data: eventContent.data };
      }
    } else {
      return {
        alert: true,
        message: fastCreate
          ? "Eventuator URL is required"
          : "Eventuator URL, launch country and ticket currency required",
      };
    }
  };

  const handleCreateFromCategory = async (data, category) => {
    let response, eventId, eventName, contentData, locationData;

    eventName = data
      .filter((obj) => obj.id === "event-name")[0]
      .value.toLowerCase();

    // generate content from category
    response = await eventContext.getEventContentDataFromCategory(category);
    if (response.alert) {
      mainContext.updateAlert(response);
      return response;
    }
    contentData = response.data;

    // create event
    response = await handleCreateCallback(
      [
        {
          id: "event-name",
          value: eventName,
        },
        {
          id: "event-country",
          value: mainContext.state.locations.tribe.country,
        },
        {
          id: "event-currency",
          value: {
            code: {
              long: mainContext.state.locations.tribe.country.currency,
            },
          },
        },
        {
          id: "event-tagline",
          value: contentData.Tagline,
        },
        {
          id: "event-details",
          value: contentData.Details,
        },
      ],
      true,
    );
    if (response.alert) {
      mainContext.updateAlert(response);
      return response;
    }
    eventId = response.data.EventId;

    // add initial location
    locationData = [
      {
        id: "new-" + idGenerator(),
        order: 1,
        active: true,
        coordinates:
          mainContext.state.locations.tribe.lat +
          "," +
          mainContext.state.locations.tribe.lng,
        description: "Regular meets for " + category.id + " in this area",
        name:
          mainContext.state.locations.tribe.geo.city +
          ", " +
          mainContext.state.locations.tribe.geo.region +
          " ||1||",
        subtag: "runner",
        tag: "Location",
        user: user.identity,
      },
    ];
    response = await eventContext.prepareUpdatePlaces({
      EventId: eventId,
      key: "Locations",
      value: locationData,
      category: "runner",
    });
    if (response.alert) {
      mainContext.updateAlert(response);
      return response;
    }
    eventContext.updatePlaces(response);

    return { alert: false };
  };

  const handleJoinCallback = async (data, loader) => {
    let eventLink, eventName, eventCountry;

    eventLink = data.filter((obj) => obj.id === "event-link");
    if (eventLink && eventLink.length > 0) {
      eventLink = eventLink[0].value;
      const parsedLinkDataUrl = parseEntzyLinkToDataUrl(eventLink);
      eventName = parsedLinkDataUrl.name;
      eventCountry = parsedLinkDataUrl.country;
    } else {
      eventName = data
        .filter((obj) => obj.id === "event-name")[0]
        .value.toLowerCase();
      eventCountry = data.filter((obj) => obj.id === "event-country")[0].value
        .code.short;
    }

    if (eventCountry && eventName) {
      const element = document.getElementById("anchor-main-app");
      if (element) {
        eventContext.state.toolbox.scrollIntoViewIfNeeded(element, true);
      }
      if (loader) {
        handleLoading(true);
      }
      const eventContent = await eventContext.prepareJoinEvent({
        country: eventCountry,
        name: eventName,
      });
      if (eventContent.alert) {
        if (loader) {
          handleLoading(false);
          mainContext.updateAlert({
            show: true,
            message: eventContent.message,
          });
        }
        // on error reset any open event flag to prevent loops
        mainContext.updateViewerTrail({
          openEvent: null,
        });
        return eventContent;
      }
      const startData = await eventContext.prepareStartEvent(eventContent.data);
      const startPayload = {
        startEvent: true,
        params: [eventContent, startData, "join"],
      };
      // navigate to event runner page with start callback payload
      mainContext.updateViewerTrail({
        menuSourcePage: "eventuators",
        openEvent: null, // reset any open event flag
      });
      mainContext.selectMenu("e");
      navigate(eventContent.urlComponents.relative, {
        state: startPayload,
      });
      return { alert: false };
    } else {
      return {
        alert: true,
        message: "Eventuator name or URL is required",
      };
    }
  };
  const cbHandleJoinCallback = useCallback(handleJoinCallback, [
    eventContext,
    mainContext,
    navigate,
  ]);

  const handleArchiveEvent = async (event) => {
    const update = {
      EventId: event.EventId,
      Url: event.Url,
      unarchive: isEventArchived(event) ? true : false,
    };
    setArchiving(update);
    const response = await mainContext.prepareArchiveEvent(update);
    if (response.alert) {
      setArchiving(response);
      mainContext.updateAlert(response);
      return response;
    } else {
      mainContext.archiveEvent(response);
      setArchiving(null);
      return { alert: false };
    }
  };
  const handleRemoveEvent = async (event) => {
    const update = {
      EventId: event.EventId,
      Url: event.Url,
      owner: isViewerEventOwner(event),
      manager: isViewerEventManager(event),
    };
    setArchiving(update);

    const response = await eventContext.preparePinEvent({
      EventId: event.EventId,
      pinned: false,
    });
    if (response.alert) {
      setArchiving(response);
      mainContext.updateAlert(response);
      return response;
    } else {
      setArchiving(null);
      mainContext.removeEvent({ EventId: event.EventId });
      setLoading(false);
      return { alert: false };
    }

    // const response = await mainContext.prepareRemoveEvent(update);
    // if (response.alert) {
    //   setArchiving(response);
    //   return response;
    // } else {
    //   setArchiving(null);
    //   mainContext.removeEvent(response);
    //   return { alert: false };
    // }
  };

  const handleManaging = async () => {
    mainContext.updateViewerTrail({
      eventMenuView: !mainContext.state.viewer.trail.eventMenuView,
    });
  };
  const handleEditing = async () => {
    mainContext.updateViewerTrail({
      editingEventFeed: !mainContext.state.viewer.trail.editingEventFeed,
    });
  };
  const handleShowArchived = async () => {
    const showArchivedEvents =
      !mainContext.state.viewer.trail.showArchivedEvents;
    setLoading(true);
    const response = await mainContext.preparePullViewerEvents({
      showArchivedEvents,
    });
    if (response.alert) {
      mainContext.updateAlert(response);
    } else {
      mainContext.pullViewerEvents(response);
    }
    mainContext.updateViewerTrail({ showArchivedEvents });
    setLoading(false);
  };

  const handleShowInfo = async () => {
    setShowInfo(!showInfo);
  };

  const handleShowJoinForm = async () => {
    setShowJoinForm(!showJoinForm);

    setShowCreateOptions(false);
    setShowCreateForm(false);
  };

  const handleShowCreateOptions = async () => {
    setShowCreateOptions(!showCreateOptions);

    setShowCreateForm(false);
    setShowJoinForm(false);
  };
  const handleShowCreateForm = async () => {
    setShowCreateForm(!showCreateForm);

    setShowJoinForm(false);
  };
  const handleShowCreateByActivity = async () => {
    setShowCreateByActivity(true);
    setShowCreateByPlace(false);

    setShowCreateForm(false);
    setShowJoinForm(false);
  };
  const handleShowCreateByPlace = async () => {
    setShowCreateByPlace(true);
    setShowCreateByActivity(false);

    setShowCreateForm(false);
    setShowJoinForm(false);
  };

  const handleShowJoinByLink = async () => {
    setShowJoinByLink(!showJoinByLink);
  };

  // const handleShowSearch = async (visibile) => {
  //   mainContext.updateViewerTrail({
  //     showEventSearch:
  //       visibile !== undefined
  //         ? visibile
  //         : !mainContext.state.viewer.trail.showEventSearch,
  //   });
  // };

  const handlePinnedEventClick = async (eventId, urlComponents) => {
    return handleJoinCallback(
      [
        {
          id: "event-country",
          value: { code: { short: urlComponents.country } },
        },
        { id: "event-name", value: urlComponents.name },
      ],
      true,
    );
  };

  // const handleTabs = (event, newTab) => {
  //   setTab(newTab);
  // };
  function TabPanel(props) {
    const { children, value: tab, index, ...other } = props;
    return (
      <div
        role="tabpanel"
        hidden={tab !== index}
        id={`full-width-tabpanel-${index}`}
        aria-labelledby={`full-width-tab-${index}`}
        {...other}
      >
        {tab === index && (
          <Box className="box-default" sx={{ pt: configEntzy.APP_SPACING_MD }}>
            {children}
          </Box>
        )}
      </div>
    );
  }
  TabPanel.propTypes = {
    children: PropTypes.node,
    index: PropTypes.number.isRequired,
    value: PropTypes.number.isRequired,
  };
  function tabProps(index) {
    return {
      id: `full-width-tab-${index}`,
      "aria-controls": `full-width-tabpanel-${index}`,
    };
  }
  function tabLabel(index, count) {
    return (
      <Box
        className="box-default"
        sx={{
          pb: configEntzy.APP_SPACING_SM,
        }}
      >
        <Typography
          variant="subtitle2"
          color={
            mainContext.state.viewer.trail.joinSubTab === index
              ? "primary"
              : "white"
          }
        >
          <span>
            <span>
              {index === 2 ? "Riding" : index === 1 ? "Running" : "All"}
            </span>
            <span>&nbsp;&nbsp;&nbsp;&nbsp;</span>
            <span
              className={
                (count > 0 ? "bg-black" : "bg-white") +
                " shadow-default rounded"
              }
              style={{
                color: count > 0 ? "white" : "black",
              }}
            >
              <span>&nbsp;</span>
              {count}
              <span>&nbsp;</span>
            </span>
          </span>
        </Typography>
      </Box>
    );
  }

  const handleRefresh = async () => {
    const response = await Promise.all([
      mainContext.preparePullNotifications({
        Category: null,
      }),
      mainContext.preparePullViewerEvents({
        nextToken: null,
      }),
    ]);
    if (response.filter((item) => item.alert).length > 0) {
      mainContext.updateAlert({
        alert: true,
        message:
          "Hmm unable to refresh content on that try. Give it another go or contact us if this problem persists.",
      });
      return true;
    } else {
      mainContext.pullNotifications(response[0]);
      mainContext.pullViewerEvents(response[1]);
      return true;
    }
  };

  const handlePullMore = async () => {
    setLoadingMore(true);
    const response = await mainContext.preparePullViewerEvents({
      showArchivedEvents: mainContext.state.viewer.trail.showArchivedEvents,
      nextToken: mainContext.state.viewer.events.nextToken,
    });
    if (response.alert) {
      mainContext.updateAlert(response);
    } else {
      mainContext.pullViewerEvents(response);
    }
    setLoadingMore(false);
  };

  // const handleOpenSearch = () => {
  //   const value = mainContext.state.viewer.trail.search ? null : "inspiration";
  //   mainContext.updateViewerTrail({
  //     search: value,
  //   });
  // };

  const handleOpenTransactions = () => {
    mainContext.setMemberMessageViewer({
      open: false,
    });
    mainContext.setMemberTransactionViewer({
      open: mainContext.state.memberTransactions.viewer.open ? false : true,
    });
  };

  const events =
    mainContext.state.viewer.trail.joinSubTab === 2
      ? mainContext.state.viewer.events.riders.concat(
          mainContext.state.viewer.events.archived.filter(
            (obj) => obj.SubCategory === "archived",
          ),
        )
      : mainContext.state.viewer.trail.joinSubTab === 1
      ? mainContext.state.viewer.events.runners.concat(
          mainContext.state.viewer.events.archived.filter((obj) =>
            ["owner-archived", "manager-archived"].includes(obj.SubCategory),
          ),
        )
      : mainContext.state.viewer.events.active.concat(
          mainContext.state.viewer.events.archived,
        );

  // effect to call tribe location settings when create tab is active
  useEffect(() => {
    const handlePullTribeSettings = async () => {
      setLoading(true);
      const response = await mainContext.preparePullTribeSettings();
      if (response.alert) {
        mainContext.updateAlert(response);
        return true;
      }
      if (response.data) {
        mainContext.updateLocation({
          type: "tribe",
          data: response.data,
        });
      }
      setLoading(false);
    };
    if (mainContext.state.viewer.trail.joinTab === 1) {
      if (mainContext.state.locations.tribe.expires) {
        if (dayjs().isAfter(mainContext.state.locations.tribe.expires)) {
          handlePullTribeSettings();
        }
      } else {
        handlePullTribeSettings();
      }
    }
  }, [mainContext, mainContext.state.viewer.trail.joinTab]);

  // effect that listens for open event flag in main context
  useEffect(() => {
    if (mainContext.state.viewer.trail.openEvent) {
      const eventUrl = mainContext.state.viewer.trail.openEvent;
      const urlComponents = eventContext.getEventUrlComponents({
        Url: eventUrl,
      });
      cbHandleJoinCallback(
        [
          {
            id: "event-country",
            value: { code: { short: urlComponents.country } },
          },
          { id: "event-name", value: urlComponents.name },
        ],
        true,
      );
    }
  }, [
    eventContext,
    mainContext.state.viewer.trail.openEvent,
    cbHandleJoinCallback,
  ]);

  const renderCreateForm = () => {
    return (
      <Box className="box-default">
        <Drawer
          anchor="bottom"
          open={showCreateForm}
          onClose={handleShowCreateForm}
        >
          <Box
            className="box-default"
            sx={{
              mb: configEntzy.APP_SPACING_LG,
              p: configEntzy.APP_SPACING_MD,
            }}
            // hidden={!showCreateForm}
          >
            <Box
              className="box-default text-right"
              sx={{
                pt: configEntzy.APP_SPACING_MD2X,
                pr: configEntzy.APP_SPACING_MD2X,
              }}
            >
              <Typography variant="h3">
                <FontAwesomeIcon
                  icon={iconClose}
                  className="action-pointer"
                  onClick={handleShowCreateForm}
                />
              </Typography>
            </Box>
            <Box
              className="box-default"
              sx={{
                pt: configEntzy.APP_SPACING_LG,
                pb: configEntzy.APP_SPACING_MD,
              }}
            >
              <Typography variant="subtitle2">
                <span className="fa-layers fa-fw fa-3x">
                  <FontAwesomeIcon
                    icon={iconNewRunner}
                    transform="up-8 left-20"
                    style={{
                      color: "rgb(255, 243, 230)",
                    }}
                  />
                  <FontAwesomeIcon
                    icon={iconEventuators}
                    transform="up-8"
                    color="orange"
                  />
                </span>
              </Typography>
              <Typography
                variant="subtitle2"
                color="primary"
                className="upper-case"
                sx={{
                  mt: configEntzy.APP_SPACING_MD,
                }}
              >
                New Eventuator
              </Typography>
            </Box>
            <Box
              className="box-default"
              sx={{
                pb: configEntzy.APP_SPACING_LG,
              }}
            >
              <Typography variant="subtitle2">
                Let's get going with the basics
              </Typography>
            </Box>
            <Container maxWidth="xs">
              <InputForm
                navigate={props.navigate}
                fields={[
                  {
                    id: "event-country",
                    type: "selector-country",
                    label: "Country where launches will be held",
                    value: null,
                    required: true,
                  },
                  {
                    id: "event-currency",
                    type: "selector-currency",
                    label: "Currency for any transactions",
                    value: null,
                    required: true,
                  },
                  {
                    id: "event-name",
                    type: "text-standard",
                    label: "Eventuator Name",
                    value: "",
                    alphanumeric: true,
                    lowercase: true,
                    required: true,
                    maxLength:
                      eventContext.state.constants.events.maxNameLength,
                  },
                ]}
                submitText="Create"
                callback={handleCreateCallback}
                // cancel={handleShowCreateForm}
                // cancelText="Cancel"
                dynamicPreviewText={{
                  header: "Your Eventuator URL:",
                  values: [
                    { type: "fixed", value: configEntzy.APP_URL },
                    { type: "fixed", value: "/" },
                    {
                      type: "field",
                      id: "event-country",
                      key: "code",
                      subKey: "short",
                    },
                    { type: "fixed", value: "/" },
                    { type: "field", id: "event-name" },
                  ],
                }}
                footNotes={[
                  "These core settings cannot be changed after creation.",
                  "Select worldwide if your launches will be multi-country.",
                ]}
              />
            </Container>
          </Box>
        </Drawer>
      </Box>
    );
  };

  const renderJoinForm = () => {
    return (
      <Drawer anchor="bottom" open={showJoinForm} onClose={handleShowJoinForm}>
        <Box
          className="box-default"
          sx={{
            mb: configEntzy.APP_SPACING_HL,
            p: configEntzy.APP_SPACING_MD,
          }}
        >
          <Box
            className="box-default text-right"
            sx={{
              pt: configEntzy.APP_SPACING_MD2X,
              pr: configEntzy.APP_SPACING_MD2X,
            }}
          >
            <Typography variant="h3">
              <FontAwesomeIcon
                icon={iconClose}
                className="action-pointer"
                onClick={handleShowJoinForm}
              />
            </Typography>
          </Box>
          <Box
            className="box-default"
            sx={{
              pt: configEntzy.APP_SPACING_MD2X,
              pb: configEntzy.APP_SPACING_MD,
            }}
          >
            <Typography variant="subtitle2">
              <span className="fa-layers fa-fw fa-3x">
                <FontAwesomeIcon
                  icon={iconNewRider}
                  transform="up-8 left-20"
                  style={{ color: "orange" }}
                />
                <FontAwesomeIcon icon={iconEventuators} transform="up-8" />
              </span>
            </Typography>
            <Typography
              variant="subtitle2"
              color="primary"
              className="upper-case"
            >
              Join Eventuator
            </Typography>
          </Box>
          <Box className="box-default">
            <Typography variant="subtitle2">
              Use a link to join in-play activity
            </Typography>
          </Box>

          <Container maxWidth="xs">
            <Box
              className="box-default action-pointer"
              onClick={handleShowJoinByLink}
              sx={{
                pt: configEntzy.APP_SPACING_MD,
                pb: configEntzy.APP_SPACING_MD2X,
              }}
            >
              <Box
                className="box-default half-width"
                sx={{
                  py: configEntzy.APP_SPACING_MD,
                  color: !showJoinByLink ? "orange" : "white",
                  borderBottom: !showJoinByLink
                    ? "2px solid orange"
                    : "2px solid transparent",
                }}
              >
                <Typography variant="subtitle2" className="upper-case">
                  <span>Enter Link</span>
                </Typography>
              </Box>
              <Box
                className="box-default half-width"
                sx={{
                  py: configEntzy.APP_SPACING_MD,
                  color: showJoinByLink ? "orange" : "white",
                  borderBottom: showJoinByLink
                    ? "2px solid orange"
                    : "2px solid transparent",
                }}
              >
                <Typography variant="subtitle2" className="upper-case">
                  <span>Paste Link</span>
                </Typography>
              </Box>
            </Box>

            <Box
              className="box-default"
              sx={{
                minHeight: configEntzy.AVATAR_CONTAINER_XL2X,
              }}
            >
              <Grow in={!showJoinByLink} timeout={500}>
                <Box className="box-default" hidden={showJoinByLink}>
                  <InputForm
                    navigate={props.navigate}
                    fields={[
                      {
                        id: "event-country",
                        type: "selector-country",
                        label: "Eventuator country",
                        value: null,
                        required: true,
                      },
                      {
                        id: "event-name",
                        type: "text-standard",
                        placeholder: "Eventuator name",
                        value: "",
                        alphanumeric: true,
                        lowercase: true,
                        required: true,
                        alignCenter: true,
                        maxLength:
                          eventContext.state.constants.events.maxNameLength +
                          10, // allow for any historical length changes
                      },
                    ]}
                    submitText="Go"
                    // submitType="focus"
                    dynamicPreviewText={{
                      header: "Joining Eventuator:",
                      values: [
                        { type: "fixed", value: configEntzy.APP_URL },
                        { type: "fixed", value: "/" },
                        {
                          type: "field",
                          id: "event-country",
                          key: "code",
                          subKey: "short",
                        },
                        { type: "fixed", value: "/" },
                        { type: "field", id: "event-name" },
                      ],
                    }}
                    callback={handleJoinCallback}
                  />
                </Box>
              </Grow>

              <Grow in={showJoinByLink} timeout={500}>
                <Box className="box-default" hidden={!showJoinByLink}>
                  <InputForm
                    navigate={props.navigate}
                    fields={[
                      {
                        id: "event-link",
                        type: "text-standard",
                        placeholder: "Eventuator link",
                        value: "",
                        required: true,
                        lowercase: true,
                        alignCenter: true,
                        maxLength:
                          eventContext.state.constants.events.maxNameLength +
                          50, // allow for URL
                      },
                    ]}
                    submitText="Go"
                    callback={handleJoinCallback}
                  />
                </Box>
              </Grow>
            </Box>
          </Container>
        </Box>
      </Drawer>
    );
  };

  const RenderNavBar = () => {
    return (
      <Box className="box-default">
        <Box
          className="box-default bg-black-t50 shadow-default"
          sx={{
            mb: configEntzy.APP_SPACING_MD,
            p: configEntzy.APP_SPACING_SM,
            borderRadius: configEntzy.BORDER_SIZE_LG,
          }}
        >
          <Box
            className="box-inline left"
            sx={{
              p: configEntzy.APP_SPACING_MD,
            }}
          >
            <Typography variant="subtitle2" color="white">
              {mainContext.state.viewer.trail.joinSubTab === 2
                ? "Eventuators you Ride"
                : mainContext.state.viewer.trail.joinSubTab === 1
                ? "Eventuators you Run"
                : "Your Eventuators"}
            </Typography>
          </Box>

          <Box
            className="box-inline right action-pointover"
            sx={{
              // width: managing ? "36%" : "12%",
              p: configEntzy.APP_SPACING_MD,
            }}
            onClick={handleManaging}
          >
            <Typography variant="subtitle2" color="white">
              <span>Actions&nbsp;</span>
              <FontAwesomeIcon
                icon={
                  mainContext.state.viewer.trail.eventMenuView
                    ? iconClose
                    : iconDropMenu
                }
                transform="grow-8"
                fixedWidth
              />
            </Typography>
          </Box>

          {/* <Box
            className="box-inline right action-pointover"
            sx={{
              p: configEntzy.APP_SPACING_MD,
            }}
            onClick={handleShowJoinForm}
            hidden={mainContext.state.viewer.trail.eventMenuView}
          >
            <Typography variant="subtitle2" color="white">
              <FontAwesomeIcon
                icon={iconNewRider}
                transform="grow-8"
                fixedWidth
              />
            </Typography>
          </Box>
          <Box
            className="box-inline right action-pointover"
            sx={{
              p: configEntzy.APP_SPACING_MD,
            }}
            onClick={handleShowCreateForm}
            hidden={mainContext.state.viewer.trail.eventMenuView}
          >
            <Typography variant="subtitle2" color="white">
              <FontAwesomeIcon
                icon={iconNewRunner}
                transform="grow-8"
                fixedWidth
              />
            </Typography>
          </Box> */}
        </Box>
        <Box
          className="box-default bg-black-t50 shadow-default"
          sx={{
            mb: configEntzy.APP_SPACING_MD,
            p: configEntzy.APP_SPACING_MD,
            borderRadius: configEntzy.BORDER_SIZE_LG,
          }}
          hidden={!mainContext.state.viewer.trail.eventMenuView}
        >
          <Box className="box-default">
            <Box
              className="box-default"
              sx={{
                p: configEntzy.APP_SPACING_SM,
              }}
            >
              <ActionBoxButton
                variant="contained"
                bgColor="primary.main"
                color="black"
                size="medium"
                type="button"
                onClick={handleShowCreateForm}
                text={showCreateForm ? "Close" : "New Eventuator"}
                startIcon={
                  <FontAwesomeIcon
                    icon={showCreateForm ? iconClose : iconNewRunner}
                    className="fa-beat"
                    style={{
                      "--fa-animation-duration": "1.5s",
                      "--fa-beat-scale": 1.1,
                    }}
                    transform="grow-4 right-2"
                    fixedWidth
                  />
                }
              />
            </Box>
            <Box
              className="box-default"
              sx={{
                p: configEntzy.APP_SPACING_SM,
              }}
            >
              <ActionBoxButton
                variant="contained"
                bgColor="primary.main"
                color="black"
                size="medium"
                type="button"
                onClick={handleShowJoinForm}
                text={showJoinForm ? "Close" : "Join Eventuator"}
                startIcon={
                  <FontAwesomeIcon
                    icon={showJoinForm ? iconClose : iconNewRider}
                    className="fa-beat"
                    style={{
                      "--fa-animation-duration": "1.5s",
                      "--fa-beat-scale": 1.1,
                    }}
                    transform="grow-4 right-2"
                    fixedWidth
                  />
                }
              />
            </Box>
            {/* <Box
              className="box-default"
              sx={{
                p: configEntzy.APP_SPACING_SM,
              }}
            >
              <ActionBoxButton
                variant="contained"
                bgColor="secondary.light"
                color="black"
                size="medium"
                type="button"
                onClick={handleOpenSearch}
                text={
                  mainContext.state.viewer.trail.search
                    ? "Close"
                    : "Get Inspiration"
                }
                startIcon={
                  <FontAwesomeIcon
                    icon={
                      mainContext.state.viewer.trail.search
                        ? iconClose
                        : iconInspiration
                    }
                    className="fa-beat"
                    style={{
                      "--fa-animation-duration": "1.5s",
                      "--fa-beat-scale": 1.1,
                    }}
                    transform="grow-4 right-2"
                    fixedWidth
                  />
                }
              />
            </Box> */}
            <Box
              className="box-default"
              sx={{
                p: configEntzy.APP_SPACING_SM,
              }}
            >
              <ActionBoxButton
                variant="contained"
                bgColor="dusk.main"
                color="white"
                size="medium"
                type="button"
                onClick={handleOpenTransactions}
                text={
                  mainContext.state.memberTransactions.viewer.open
                    ? "Close"
                    : "Open Financials"
                }
                startIcon={
                  <FontAwesomeIcon
                    icon={
                      mainContext.state.memberTransactions.viewer.open
                        ? iconClose
                        : iconFinancials
                    }
                    className="fa-beat"
                    style={{
                      "--fa-animation-duration": "1.5s",
                      "--fa-beat-scale": 1.1,
                    }}
                    transform="grow-4 right-2"
                    fixedWidth
                  />
                }
              />
            </Box>
            <Box
              className="box-default"
              sx={{
                p: configEntzy.APP_SPACING_SM,
              }}
            >
              <ActionBoxButton
                variant="contained"
                bgColor="dusk.main"
                color="white"
                size="medium"
                type="button"
                onClick={handleShowArchived}
                text={
                  mainContext.state.viewer.trail.showArchivedEvents
                    ? "Hide Archived"
                    : "Show Archived"
                }
                startIcon={
                  <FontAwesomeIcon
                    icon={
                      mainContext.state.viewer.trail.showArchivedEvents
                        ? iconClose
                        : iconArchived
                    }
                    className="fa-beat"
                    style={{
                      "--fa-animation-duration": "1.5s",
                      "--fa-beat-scale": 1.1,
                    }}
                    transform="grow-4 right-2"
                    fixedWidth
                  />
                }
              />
            </Box>
            {events.length > 0 && (
              <Box
                className="box-default"
                sx={{
                  p: configEntzy.APP_SPACING_SM,
                }}
              >
                <ActionBoxButton
                  variant="contained"
                  bgColor="dusk.main"
                  color="white"
                  size="medium"
                  type="button"
                  onClick={handleEditing}
                  text={
                    mainContext.state.viewer.trail.editingEventFeed
                      ? "Close Editing"
                      : "Edit Feed"
                  }
                  startIcon={
                    <FontAwesomeIcon
                      icon={
                        mainContext.state.viewer.trail.editingEventFeed
                          ? iconClose
                          : iconEdit
                      }
                      className="fa-beat"
                      style={{
                        "--fa-animation-duration": "1.5s",
                        "--fa-beat-scale": 1.1,
                      }}
                      transform="grow-4 right-2"
                      fixedWidth
                    />
                  }
                />
              </Box>
            )}
          </Box>
          {/* </AccordionDetails>
          </Accordion> */}
          {/* </Zoom> */}
        </Box>
      </Box>
    );
  };

  const EventuateData = (props) => {
    const [eventFilter, setEventFilter] = useState("");

    const filteredEvents = events.filter((event) => {
      const searchString = eventFilter.toLowerCase();
      return (
        event.Url.toLowerCase().includes(searchString) ||
        (event.Tagline && event.Tagline.toLowerCase().includes(searchString))
      );
    });
    return (
      <Box className="box-default">
        <RenderNavBar />
        {/* <EventSearch {...props} /> */}
        <Box className="box-default">
          {events.length === 0 ? (
            <Box
              className="box-default bg-black-t25 shadow-default"
              sx={{
                pt: configEntzy.APP_SPACING_HL,
                pb: configEntzy.APP_SPACING_HL,
                borderRadius: configEntzy.BORDER_SIZE_LG,
              }}
            >
              <Typography variant="h1" noWrap={true}>
                <FontAwesomeIcon icon={iconEventuators} fixedWidth />
              </Typography>
              <Typography
                variant="subtitle2"
                sx={{
                  mt: configEntzy.APP_SPACING_MD,
                }}
              >
                {mainContext.state.viewer.trail.showArchivedEvents ? (
                  <span>Nothing currently archived</span>
                ) : (
                  <span>Nothing in your feed yet</span>
                )}
              </Typography>
              <Typography
                variant="body1"
                sx={{ mt: configEntzy.APP_SPACING_MD }}
              >
                <em>
                  {mainContext.state.viewer.trail.showArchivedEvents ? (
                    <span>Any eventuators you archive will appear here</span>
                  ) : mainContext.state.viewer.trail.joinSubTab === 2 ? (
                    <span>Eventuators you ride will appear here</span>
                  ) : mainContext.state.viewer.trail.joinSubTab === 1 ? (
                    <span>Eventuators you run will appear here</span>
                  ) : (
                    <span>Your eventuator activity will appear here</span>
                  )}
                </em>
              </Typography>
              <Typography variant="body1">
                <em>
                  {mainContext.state.viewer.trail.showArchivedEvents ? (
                    <span>Manage archives by editing your feed</span>
                  ) : mainContext.state.viewer.trail.joinSubTab === 2 ? (
                    <span>Join one with a link to get started</span>
                  ) : mainContext.state.viewer.trail.joinSubTab === 1 ? (
                    <span>Create one to get started</span>
                  ) : (
                    <span>Create or join to get started</span>
                  )}
                </em>
              </Typography>
            </Box>
          ) : (
            <Box className="box-default">
              <Box
                className="box-default bg-black-t50 shadow-default"
                sx={{
                  py: configEntzy.APP_SPACING_XS3X,
                  px: configEntzy.APP_SPACING_MD,
                  mb: configEntzy.APP_SPACING_MD,
                  borderRadius: configEntzy.BORDER_SIZE_LG,
                }}
              >
                <TextField
                  fullWidth
                  variant="standard"
                  placeholder="Type to filter eventuators..."
                  value={eventFilter}
                  onChange={(e) => setEventFilter(e.target.value)}
                />
              </Box>
              {mainContext.state.viewer.trail.editingEventFeed && (
                <Box
                  className="box-default"
                  sx={{
                    mb: configEntzy.APP_SPACING_MD2X,
                  }}
                >
                  <Typography variant="body1">
                    <em>Use archive to move your archive folder</em>
                  </Typography>
                  <Typography variant="body1">
                    <em>Use remove to unpin & clear from your feed</em>
                  </Typography>
                </Box>
              )}
              {filteredEvents.map((event) => {
                return (
                  <Box
                    key={event.EventId}
                    className="box-default"
                    sx={{
                      mb:
                        events.indexOf(event) === events.length - 1
                          ? 0
                          : configEntzy.APP_SPACING_MD,
                    }}
                  >
                    <EventButton
                      user={user}
                      event={event}
                      eventContext={eventContext}
                      mainContext={mainContext}
                      size="sm"
                      onClick={handlePinnedEventClick}
                      messageCount={
                        mainContext.state.notifications.data.messages.filter(
                          (obj) =>
                            obj.MessageUrl.endsWith(
                              configEntzy.URL_POINTERS.MAIN + event.Url,
                            ) && !obj.MessageRead,
                        ).length
                      }
                      activityCount={
                        mainContext.state.notifications.data.activity.filter(
                          (obj) =>
                            obj.MessageUrl.endsWith(
                              configEntzy.URL_POINTERS.MAIN + event.Url,
                            ) &&
                            !obj.MessageRead &&
                            !counterExcludeActivityCategories.includes(
                              obj.MessageCategory,
                            ),
                        ).length
                      }
                      editing={mainContext.state.viewer.trail.editingEventFeed}
                      archiving={archiving}
                      isEventArchived={isEventArchived}
                      handleArchiveEvent={handleArchiveEvent}
                      handleRemoveEvent={handleRemoveEvent}
                    />
                  </Box>
                );
              })}
            </Box>
          )}
        </Box>
      </Box>
    );
  };

  return (
    <Box
      className="box-default"
      sx={{
        mb: configEntzy.APP_SPACING_HL,
      }}
    >
      {/* --------- user eventuators --------- */}
      {loading ? (
        <Box className="box-fixed top-left full-width full-height bg-black-t75 pop-top">
          <Box
            className="box-default text-right"
            sx={{
              p: configEntzy.APP_SPACING_LG,
            }}
          >
            <Typography variant="h1">
              <FontAwesomeIcon
                icon={iconClose}
                className="action-pointer"
                onClick={() => handleLoading(false)}
              />
            </Typography>
          </Box>
          <Box
            className="box-default"
            sx={{
              pt: configEntzy.APP_SPACING_HL,
              pb: configEntzy.APP_SPACING_HL,
            }}
          >
            <ActionLoader />
          </Box>
        </Box>
      ) : props.user.connected ? (
        <Box className="box-default">
          <HeaderMenuTag
            icon={iconEventuators}
            text={moduleInfo.name}
            handleRefresh={handleRefresh}
          />
          {/* --------- sub nav --------- */}
          {/* 
              text={
                mainContext.state.viewer.events.active.length === 1
                  ? "1 Eventuator"
                  : `${mainContext.state.viewer.events.active.length} Eventuators`
              }
          */}
          <Box
            className="box-default"
            sx={{
              pl: configEntzy.APP_SPACING_MD,
              pr: configEntzy.APP_SPACING_MD,
            }}
          >
            <Box
              className="box-default third-end-width"
              sx={{ pl: configEntzy.APP_SPACING_SM }}
            >
              <BigButton
                icon={iconTabList}
                size="tab"
                noOuterPadding={true}
                bgColor={
                  mainContext.state.viewer.trail.joinTab === 2
                    ? "black"
                    : undefined
                }
                borderColor={
                  mainContext.state.viewer.trail.joinTab === 2
                    ? undefined
                    : "#333"
                }
                borderGlow={mainContext.state.viewer.trail.joinTab === 2}
                onClick={() => handleMainTab(null, 2)}
              />
            </Box>
            <Box
              className="box-default third-mid-width"
              sx={{
                pl: configEntzy.APP_SPACING_SM,
                pr: configEntzy.APP_SPACING_SM,
              }}
            >
              <BigButton
                icon={iconTabCreate}
                size="tab"
                noOuterPadding={true}
                bgColor={
                  mainContext.state.viewer.trail.joinTab === 1
                    ? "black"
                    : undefined
                }
                borderColor={
                  mainContext.state.viewer.trail.joinTab === 1
                    ? undefined
                    : "#333"
                }
                borderGlow={mainContext.state.viewer.trail.joinTab === 1}
                onClick={() => handleMainTab(null, 1)}
              />
            </Box>
            <Box
              className="box-default third-end-width"
              sx={{
                pr: configEntzy.APP_SPACING_SM,
              }}
            >
              <BigButton
                icon={iconTabSearch}
                size="tab"
                noOuterPadding={true}
                bgColor={
                  mainContext.state.viewer.trail.joinTab === 0
                    ? "black"
                    : undefined
                }
                borderColor={
                  mainContext.state.viewer.trail.joinTab === 0
                    ? undefined
                    : "#333"
                }
                borderGlow={mainContext.state.viewer.trail.joinTab === 0}
                onClick={() => handleMainTab(null, 0)}
              />
            </Box>
          </Box>
          {/* --------- search bar --------- */}
          {/* {!mainContext.state.viewer.trail.showEventSearch && (
            <ModuleSubHeaderTag text="Search Eventuators" />
          )} */}
          <Grow in={mainContext.state.viewer.trail.joinTab === 0} timeout={250}>
            <Box
              className="box-default"
              sx={{
                p: configEntzy.APP_SPACING_MD,
              }}
              hidden={mainContext.state.viewer.trail.joinTab !== 0}
            >
              <MainModule module="search" {...props} />
            </Box>
          </Grow>
          {/* <Box
            className="box-default"
            sx={{
              pl: configEntzy.APP_SPACING_LG,
              pr: configEntzy.APP_SPACING_LG,
              mt: mainContext.state.viewer.trail.showEventSearch
                ? 0
                : configEntzy.APP_SPACING_NXL,
            }}
          >
            <Box
              className={
                "box-inline right relative pop-up action-pointer" +
                (mainContext.state.viewer.trail.showEventSearch
                  ? " shadow-darker"
                  : " bg-black-t25 shadow-default")
              }
              sx={{
                p: mainContext.state.viewer.trail.showEventSearch
                  ? configEntzy.APP_SPACING_SM
                  : configEntzy.APP_SPACING_SM2X,
                borderRadius: configEntzy.BORDER_SIZE_XL,
              }}
              onClick={() => handleShowSearch()}
            >
              <Typography variant="subtitle2" sx={{ textAlign: "right" }}>
                {mainContext.state.viewer.trail.showEventSearch ? (
                  <span>
                    <span>&nbsp;&nbsp;</span>
                    <span>Hide&nbsp;Search</span>
                    <span>&nbsp;&nbsp;</span>
                    <FontAwesomeIcon icon={iconClose} />
                    <span>&nbsp;</span>
                  </span>
                ) : (
                  <span>
                    <span>&nbsp;&nbsp;</span>
                    <span>Show</span>
                    <span>&nbsp;&nbsp;</span>
                    <FontAwesomeIcon icon={iconSearch} />
                    <span>&nbsp;</span>
                  </span>
                )}
              </Typography>
            </Box>
          </Box> */}

          {/* --------- eventuators create --------- */}
          <Grow in={mainContext.state.viewer.trail.joinTab === 1} timeout={250}>
            <Box
              className="box-default"
              sx={{ p: configEntzy.APP_SPACING_MD }}
              hidden={mainContext.state.viewer.trail.joinTab !== 1}
            >
              <Box
                className="box-default nooverflow"
                sx={{
                  borderRadius: configEntzy.BORDER_SIZE_XL,
                }}
              >
                <Hero
                  image={imageHeroEvents}
                  title="Create to Eventuate"
                  subtitle="Make something happen"
                  bulletList={[
                    {
                      text: showInfo
                        ? "Hide Info X"
                        : "With Simple Repeat Meets",
                      onClick: handleShowInfo,
                    },
                  ]}
                  align="center"
                />
              </Box>
              <Grow in={showInfo} timeout={250}>
                <Box
                  className="box-default bg-black-t75 shadow-default"
                  sx={{
                    mt: configEntzy.APP_SPACING_MD,
                    p: configEntzy.APP_SPACING_MD,
                    borderRadius: configEntzy.BORDER_SIZE_XL,
                  }}
                  hidden={!showInfo}
                >
                  <Box className="box-default text-justify">
                    <Container maxWidth="xs">
                      <Typography
                        variant="h6"
                        color="primary"
                        sx={{ mt: configEntzy.APP_SPACING_MD }}
                      >
                        Simple Repeat Meets{" "}
                        <FontAwesomeIcon icon={iconInfo} fixedWidth />
                      </Typography>
                      <Typography
                        variant="subtitle2"
                        sx={{ mt: configEntzy.APP_SPACING_MD2X }}
                      >
                        Eventuating is a signal call to get together.
                      </Typography>
                      <Typography
                        variant="subtitle2"
                        sx={{ mt: configEntzy.APP_SPACING_MD2X }}
                      >
                        Throw ideas out there, change things on the fly and see
                        how interests and groups evolve. Unlike traditional
                        events, eventuators launch on demand, so you can
                        experiment with ease and see what sticks.
                      </Typography>
                      <Typography
                        variant="subtitle2"
                        sx={{ mt: configEntzy.APP_SPACING_MD2X }}
                      >
                        Don't overthink the activity, just get something going.
                        Simple - regular - group gatherings are life changing,
                        so focus on things that are easily repeatable. Start
                        with public eventuators and migrate to private ones as
                        you firm up your tribes.
                      </Typography>
                      <Typography
                        variant="h6"
                        color="primary"
                        sx={{ mt: configEntzy.APP_SPACING_MD2X }}
                      >
                        How to Create
                      </Typography>
                      <Typography
                        variant="subtitle2"
                        sx={{ mt: configEntzy.APP_SPACING_MD2X }}
                      >
                        To generate activity in your area, select from one of
                        the fast create categories, or if you would like to
                        tailor the content yourself use the custom create option
                        underneath.
                      </Typography>
                      <Typography
                        variant="subtitle2"
                        sx={{ mt: configEntzy.APP_SPACING_MD2X }}
                      >
                        After creation you can still edit content either way, or
                        chat with everyone as and when people arrive, to plan on
                        the go. As soon as you are happy with your initial
                        setup, use broadcast in the eventuator settings to send
                        a signal people in the area.
                      </Typography>
                    </Container>
                  </Box>
                </Box>
              </Grow>
              {/* <ModuleSubHeaderTag text="Join In-Play Eventuators" /> */}
              {/* <ModuleSubHeaderTag text="Create Quick Eventuators" /> */}
              {/* <ModuleSubHeaderTag text="Custom Eventuators" /> */}

              <Box
                className="box-default"
                sx={{
                  mt: configEntzy.APP_SPACING_LG,
                  p: configEntzy.APP_SPACING_XS,
                }}
              >
                <Box
                  className="box-default bg-black-t50 shadow-default action-pointer"
                  sx={{
                    p: configEntzy.APP_SPACING_MD,
                    borderRadius: configEntzy.BORDER_SIZE_XL,
                  }}
                  onClick={() => {
                    navigate("/tribe");
                    scrollSnapTop();
                  }}
                >
                  <Box className="box-default">
                    <Box className="box-inline left">
                      <TextTag
                        text="Tribe Area"
                        bgColor="white"
                        color="black"
                        rounded={true}
                        edges={true}
                        noMask={true}
                      />
                    </Box>
                    <Box className="box-inline right">
                      <Typography
                        variant="subtitle2"
                        color={
                          mainContext.state.locations.tribe.hydrated
                            ? "success"
                            : "error"
                        }
                      >
                        <FontAwesomeIcon
                          icon={iconSignalArea}
                          transform="grow-8 left-4 down-4"
                          fixedWidth
                        />
                      </Typography>
                    </Box>
                  </Box>
                  <Box className="box-default text-left">
                    {mainContext.state.locations.tribe.hydrated ? (
                      <Fragment>
                        <TextTag
                          text={
                            mainContext.state.locations.tribe.country.name +
                            " (" +
                            mainContext.state.locations.tribe.country.currency +
                            ")"
                          }
                          color="white"
                          rounded={true}
                          edges={true}
                        />
                        {mainContext.state.locations.tribe.city && (
                          <TextTag
                            text={
                              "Near " +
                              mainContext.state.locations.tribe.city +
                              " (" +
                              mainContext.state.locations.tribe.radius +
                              "m)"
                            }
                            color="white"
                            rounded={true}
                            edges={true}
                          />
                        )}
                      </Fragment>
                    ) : (
                      <TextTag
                        text="Not Set"
                        color="white"
                        rounded={true}
                        edges={true}
                      />
                    )}
                  </Box>
                </Box>
              </Box>

              <Box
                className="box-default"
                sx={{
                  pt: configEntzy.APP_SPACING_MD2X,
                  pr: configEntzy.APP_SPACING_SM,
                }}
                hidden={!showCreateOptions}
              >
                <Box
                  className="box-inline right action-pointer"
                  onClick={handleShowCreateOptions}
                >
                  <Typography variant="subtitle2" color="white">
                    <FontAwesomeIcon icon={iconClose} size="2x" fixedWidth />
                  </Typography>
                </Box>
              </Box>
              <Box className="box-default" hidden={showCreateOptions}>
                <Box
                  className="box-default half-width"
                  sx={{
                    mt: configEntzy.APP_SPACING_LG,
                    pl: configEntzy.APP_SPACING_XS,
                    pr: configEntzy.APP_SPACING_SM3X,
                  }}
                >
                  <Box
                    className="box-default bg-black-t90 shadow-purple-glow action-pointer"
                    sx={{
                      pt: configEntzy.APP_SPACING_LG,
                      pb: configEntzy.APP_SPACING_LG,
                      borderRadius: configEntzy.BORDER_SIZE_XL,
                    }}
                    onClick={handleShowJoinForm}
                  >
                    <Typography variant="h1" color="magenta">
                      <FontAwesomeIcon
                        icon={showJoinForm ? iconClose : iconJoinByLink}
                        fixedWidth
                      />
                    </Typography>
                    <Typography
                      variant="subtitle2"
                      color="white"
                      sx={{ mt: configEntzy.APP_SPACING_MD }}
                      noWrap={true}
                    >
                      Join Eventuator
                    </Typography>
                  </Box>
                </Box>
                <Box
                  className="box-default half-width"
                  sx={{
                    mt: configEntzy.APP_SPACING_LG,
                    pr: configEntzy.APP_SPACING_XS,
                    pl: configEntzy.APP_SPACING_SM3X,
                  }}
                >
                  <Box
                    className="box-default bg-black-t90 shadow-orange-glow action-pointer"
                    sx={{
                      pt: configEntzy.APP_SPACING_LG,
                      pb: configEntzy.APP_SPACING_LG,
                      borderRadius: configEntzy.BORDER_SIZE_XL,
                    }}
                    onClick={handleShowCreateOptions}
                  >
                    <Typography variant="h1" color="primary">
                      <FontAwesomeIcon icon={iconCustomCreate} fixedWidth />
                    </Typography>
                    <Typography
                      variant="subtitle2"
                      color="white"
                      sx={{ mt: configEntzy.APP_SPACING_MD }}
                      noWrap={true}
                    >
                      Create Eventuator
                    </Typography>
                  </Box>
                </Box>
              </Box>

              <Grow in={showCreateOptions} timeout={500}>
                <Box
                  className="box-default"
                  sx={{
                    p: configEntzy.APP_SPACING_XS,
                  }}
                  hidden={!showCreateOptions}
                >
                  <Box
                    className="box-default"
                    sx={{
                      mt: configEntzy.APP_SPACING_MD,
                      mb: configEntzy.APP_SPACING_MD,
                      p: configEntzy.APP_SPACING_XS,
                    }}
                  >
                    <ActionBoxButton
                      size="small"
                      text="Standard Create"
                      subText="Create without any defaults"
                      bgColor="transparent"
                      color="white"
                      borderColor="orange"
                      actionPointover={true}
                      maskBlack={true}
                      onClick={handleShowCreateForm}
                      topIcon={
                        <FontAwesomeIcon
                          icon={iconNewRunner}
                          size="2x"
                          fixedWidth
                        />
                      }
                    />
                  </Box>
                  <ModuleSubHeaderTag text="Quick Create Eventuator Ideas" />
                  <Box
                    className="box-default half-width action-pointer"
                    sx={{
                      pb: configEntzy.APP_SPACING_MD,
                      px: configEntzy.APP_SPACING_XS,
                      color: showCreateByActivity ? "white" : "inherit",
                      borderBottom: showCreateByActivity
                        ? "1px solid orange"
                        : "1px solid #555",
                    }}
                    onClick={handleShowCreateByActivity}
                  >
                    <Typography variant="subtitle2">
                      <FontAwesomeIcon
                        icon={iconCreateByActivity}
                        size="2x"
                        fixedWidth
                      />
                    </Typography>
                    <Typography variant="subtitle2">Activity Ideas</Typography>
                  </Box>
                  <Box
                    className="box-default half-width action-pointer"
                    sx={{
                      pb: configEntzy.APP_SPACING_MD,
                      px: configEntzy.APP_SPACING_XS,
                      color: showCreateByPlace ? "white" : "inherit",
                      borderBottom: showCreateByPlace
                        ? "1px solid orange"
                        : "1px solid #555",
                    }}
                    onClick={handleShowCreateByPlace}
                  >
                    <Typography variant="subtitle2">
                      <FontAwesomeIcon
                        icon={iconCreateByPlace}
                        size="2x"
                        fixedWidth
                      />
                    </Typography>
                    <Typography variant="subtitle2">Venue Ideas</Typography>
                  </Box>

                  <Box
                    className="box-default"
                    sx={{
                      pt: configEntzy.APP_SPACING_MD,
                    }}
                    hidden={!showCreateByActivity || stageCategory}
                  >
                    <Typography variant="subtitle1" color="white">
                      <em>Eventuate based on activities you enjoy</em>
                    </Typography>
                  </Box>

                  <Box
                    className="box-default"
                    sx={{
                      pt: configEntzy.APP_SPACING_MD,
                    }}
                    hidden={!showCreateByPlace || stageCategory}
                  >
                    <Typography variant="subtitle1" color="white">
                      <em>Eventuate based on venues you know or own</em>
                    </Typography>
                  </Box>

                  <Box
                    className="box-default"
                    sx={{
                      pt: configEntzy.APP_SPACING_MD2X,
                      pb: configEntzy.APP_SPACING_MD2X,
                    }}
                    hidden={!stageCategory}
                  >
                    <ModuleHeaderTag text="Ready to Create" />
                  </Box>

                  <Box
                    className="box-default"
                    sx={{
                      px: configEntzy.APP_SPACING_XS3X,
                      pt: configEntzy.APP_SPACING_MD,
                    }}
                    hidden={mainContext.state.locations.tribe.hydrated}
                  >
                    <Box
                      className="box-default shadow-darker action-pointer"
                      sx={{
                        pt: configEntzy.APP_SPACING_MD2X,
                        pb: configEntzy.APP_SPACING_MD2X,
                        borderRadius: configEntzy.BORDER_SIZE_XL,
                      }}
                      onClick={() => {
                        navigate("/tribe");
                        scrollSnapTop();
                      }}
                    >
                      <Typography variant="subtitle2" color="error">
                        <FontAwesomeIcon icon={iconSignalArea} fixedWidth />
                        <span>&nbsp;&nbsp;</span>
                        Set your tribe area to enable quick create options
                        <span>&nbsp;&nbsp;</span>
                        <FontAwesomeIcon icon={iconSignalArea} fixedWidth />
                      </Typography>
                    </Box>
                  </Box>

                  <Grow in={!stageCategory} timeout={500}>
                    <Box
                      className="box-default"
                      hidden={stageCategory}
                      sx={{
                        pt: configEntzy.APP_SPACING_MD,
                      }}
                    >
                      {meetCategories
                        .filter((cat) => {
                          if (showCreateByPlace) {
                            return cat.place;
                          }
                          return cat.activity;
                        })
                        .map((category) => (
                          <Box
                            key={category.id}
                            className="box-default"
                            sx={{ p: configEntzy.APP_SPACING_XS3X }}
                          >
                            {mainContext.state.locations.tribe.hydrated ? (
                              <Box
                                className="box-default bg-black-t90 shadow-orange action-pointer"
                                sx={{
                                  p: configEntzy.APP_SPACING_MD,
                                  borderRadius: configEntzy.BORDER_SIZE_XL,
                                }}
                                onClick={() => {
                                  setStageCategory(category);
                                }}
                              >
                                <Typography
                                  variant="subtitle2"
                                  className="upper-case"
                                >
                                  {category.id}
                                </Typography>
                                <Typography variant="subtitle2" color="primary">
                                  {category.title}
                                </Typography>
                                <Typography
                                  variant="subtitle1"
                                  color="secondary"
                                >
                                  {category.tagline}
                                </Typography>
                              </Box>
                            ) : (
                              <Box
                                className="box-default bg-black-t90 shadow-darker"
                                sx={{
                                  p: configEntzy.APP_SPACING_MD,
                                  borderRadius: configEntzy.BORDER_SIZE_XL,
                                }}
                              >
                                <Box className="box-default zero-height">
                                  <Typography
                                    variant="subtitle2"
                                    className="text-right"
                                    color="error"
                                  >
                                    <FontAwesomeIcon
                                      icon={iconDisabled}
                                      fixedWidth
                                    />
                                  </Typography>
                                </Box>
                                <Typography
                                  variant="subtitle2"
                                  className="upper-case"
                                  sx={{
                                    opacity: 0.8,
                                  }}
                                >
                                  {category.id}
                                </Typography>
                                <Typography
                                  variant="subtitle2"
                                  color="primaryDisabled"
                                  sx={{
                                    opacity: 0.6,
                                  }}
                                >
                                  {category.title}
                                </Typography>
                                <Typography
                                  variant="subtitle1"
                                  color="secondaryDisabled"
                                  sx={{
                                    opacity: 0.4,
                                  }}
                                >
                                  {category.tagline}
                                </Typography>
                              </Box>
                            )}
                          </Box>
                        ))}
                      <ModuleSubHeaderTag text="Support" />
                      <Box
                        className="box-default"
                        sx={{ p: configEntzy.APP_SPACING_XS }}
                      >
                        <Box className="box-inline">
                          <ActionBoxButton
                            size="small"
                            text="Request a Category"
                            subText="Contact us for suggestions"
                            bgColor="transparent"
                            color="white"
                            borderColor="#333"
                            actionPointover={true}
                            maskBlack={true}
                            onClick={() => {
                              navigate("/contact");
                              scrollSnapTop();
                            }}
                            topIcon={
                              <FontAwesomeIcon
                                icon={iconContact}
                                size="2x"
                                fixedWidth
                              />
                            }
                          />
                        </Box>
                      </Box>
                    </Box>
                  </Grow>
                  <Grow in={stageCategory ? true : false} timeout={500}>
                    <Box className="box-default">
                      {stageCategory && (
                        <Container maxWidth="xs">
                          <Box
                            className="box-default bg-black-t50 shadow-default"
                            sx={{
                              mb: configEntzy.APP_SPACING_MD2X,
                              p: configEntzy.APP_SPACING_MD,
                              borderRadius: configEntzy.BORDER_SIZE_XL,
                            }}
                          >
                            <Typography variant="subtitle2" color="primary">
                              Would you like to edit the name?
                            </Typography>
                            <Typography variant="subtitle1">
                              This can't be changed later
                            </Typography>
                          </Box>
                          <InputForm
                            navigate={props.navigate}
                            fields={[
                              {
                                id: "event-name",
                                type: "text-standard",
                                label: "Eventuator Name",
                                value:
                                  stageCategory.id.replace(
                                    /[^a-zA-Z0-9]/g,
                                    "",
                                  ) +
                                  "_" +
                                  idTimeGenerator(),
                                alphanumeric: true,
                                required: true,
                                maxLength:
                                  eventContext.state.constants.events
                                    .maxNameLength,
                              },
                            ]}
                            submitText="Create"
                            callback={(data) => {
                              return handleCreateFromCategory(
                                data,
                                stageCategory,
                              );
                            }}
                            cancel={() => {
                              setStageCategory(null);
                            }}
                            cancelText="Cancel"
                            cancelAutoConfirm={true}
                            hideFormAlerts={true}
                            dynamicPreviewText={{
                              header: "Your Eventuator URL:",
                              values: [
                                { type: "fixed", value: configEntzy.APP_URL },
                                { type: "fixed", value: "/" },
                                {
                                  type: "fixed",
                                  value:
                                    mainContext.state.locations.tribe.country
                                      .code.short,
                                },
                                { type: "fixed", value: "/" },
                                { type: "field", id: "event-name" },
                              ],
                            }}
                            footNotes={[
                              "Fast create uses your tribe country defaults",
                            ]}
                          />
                        </Container>
                      )}
                    </Box>
                  </Grow>
                </Box>
              </Grow>
            </Box>
          </Grow>

          {/* --------- eventuators list --------- */}
          {/* {mainContext.state.viewer.trail.showEventSearch && (
            <ModuleSubHeaderTag text="Eventuator Feed" />
          )} */}
          <Grow in={mainContext.state.viewer.trail.joinTab === 2} timeout={250}>
            <Box
              className="box-default"
              sx={{
                p: configEntzy.APP_SPACING_MD,
                borderRadius: configEntzy.BORDER_SIZE_LG,
                color: "white",
              }}
              hidden={mainContext.state.viewer.trail.joinTab !== 2}
            >
              <Container maxWidth="md" disableGutters>
                {mainContext.state.viewer.events.hydrated && (
                  <Box className="box-default">
                    <Box className="box-default">
                      <Box className="box-default">{renderCreateForm()}</Box>
                      <Box className="box-default" hidden={showCreateForm}>
                        {renderJoinForm()}
                      </Box>

                      {/* <CounterAvatar
                  size="sm"
                  count={mainContext.state.viewer.events.active.length}
                /> */}
                    </Box>
                    <Box className="box-default">
                      <Box className="box-default">
                        <Tabs
                          value={mainContext.state.viewer.trail.joinSubTab}
                          onChange={handleSubTab}
                          indicatorColor="primary"
                          textColor="inherit"
                          variant="fullWidth"
                          aria-label="Pinned Events"
                        >
                          <Tab
                            label={tabLabel(
                              0,
                              mainContext.state.viewer.events.active.length,
                            )}
                            {...tabProps(0)}
                            wrapped={true}
                            sx={{
                              fontSize: configEntzy.FONT_SCALE_LG,
                              pt: configEntzy.APP_SPACING_MD,
                              pb: configEntzy.APP_SPACING_MD,
                            }}
                          />
                          <Tab
                            label={tabLabel(
                              1,
                              mainContext.state.viewer.events.runners.length,
                            )}
                            {...tabProps(1)}
                            sx={{
                              fontSize: configEntzy.FONT_SCALE_LG,
                              pt: configEntzy.APP_SPACING_MD,
                              pb: configEntzy.APP_SPACING_MD,
                            }}
                          />
                          <Tab
                            label={tabLabel(
                              2,
                              mainContext.state.viewer.events.riders.length,
                            )}
                            {...tabProps(2)}
                            sx={{
                              fontSize: configEntzy.FONT_SCALE_LG,
                              pt: configEntzy.APP_SPACING_MD,
                              pb: configEntzy.APP_SPACING_MD,
                            }}
                          />
                        </Tabs>
                      </Box>
                      <TabPanel
                        value={mainContext.state.viewer.trail.joinSubTab}
                        index={0}
                      >
                        <EventuateData {...props} />
                      </TabPanel>
                      <TabPanel
                        value={mainContext.state.viewer.trail.joinSubTab}
                        index={1}
                      >
                        <EventuateData {...props} />
                      </TabPanel>
                      <TabPanel
                        value={mainContext.state.viewer.trail.joinSubTab}
                        index={2}
                      >
                        <EventuateData {...props} />
                      </TabPanel>
                    </Box>

                    {mainContext.state.viewer.events.nextToken &&
                      Object.values(
                        mainContext.state.viewer.events.nextToken,
                      ).some((item) => item) && (
                        <Box
                          className="box-default"
                          sx={{
                            pt: configEntzy.APP_SPACING_LG,
                            pb: configEntzy.APP_SPACING_LG,
                          }}
                        >
                          <MoreButton
                            variant="contained"
                            size="small"
                            type="button"
                            color="bright"
                            text="More"
                            loading={loadingMore}
                            onClick={handlePullMore}
                          />
                        </Box>
                      )}
                  </Box>
                )}
              </Container>
            </Box>
          </Grow>
        </Box>
      ) : (
        <Box className="box-default">
          <Container maxWidth="md" disableGutters>
            <Grow in={true} timeout={1000}>
              <Box className="box-default">
                <Box
                  className="box-default nooverflow"
                  sx={{
                    pt: configEntzy.APP_SPACING_MD2X,
                    pl: configEntzy.APP_SPACING_MD2X,
                    pr: configEntzy.APP_SPACING_MD2X,
                    pb: configEntzy.APP_SPACING_MD,
                  }}
                >
                  <Box
                    className="box-default nooverflow"
                    sx={{
                      borderRadius: configEntzy.BORDER_SIZE_XL,
                    }}
                  >
                    <Hero
                      image={imageHeroEvents}
                      eyebrow="About"
                      title="Eventuators"
                      subtitle="Entzy helps fill your calendar with group activities using eventuators. These are event launchers designed to trigger activity when everyone is available. Have a play with a simulation below or join in-play activity if you already have a link."
                      bulletList={[]}
                      align="center"
                    />
                  </Box>
                </Box>
                {/* ----- try outs ----- */}
                <Box
                  className="box-default nooverflow"
                  sx={{
                    px: configEntzy.APP_SPACING_MD2X,
                  }}
                >
                  <Box
                    className="box-default bg-black-t50"
                    sx={{
                      p: configEntzy.APP_SPACING_MD,
                      borderRadius: configEntzy.BORDER_SIZE_XL,
                    }}
                  >
                    <Box className="box-default half-width">
                      <Box
                        className="box-inline left"
                        sx={{
                          width: configEntzy.AVATAR_SIZE_LG,
                        }}
                      >
                        <BigButton
                          bgColor="transparent"
                          icon={showCreateForm ? iconClose : iconNewRunner}
                          text={showCreateForm ? "Close" : "Try as Runner"}
                          subText={showCreateForm ? " " : "Event Organizer"}
                          onClick={handleShowCreateForm}
                        />
                      </Box>
                    </Box>
                    <Box className="box-default half-width">
                      <Box
                        className="box-inline right"
                        sx={{
                          width: configEntzy.AVATAR_SIZE_LG,
                        }}
                      >
                        <BigButton
                          bgColor="transparent"
                          icon={showJoinForm ? iconClose : iconNewRider}
                          text={showJoinForm ? "Close" : "Join as Rider"}
                          subText={showJoinForm ? " " : "Event Guest"}
                          onClick={handleShowJoinForm}
                        />
                      </Box>
                    </Box>
                  </Box>
                </Box>
                {/* ----- spotlight examples ----- */}
                <Box
                  className="box-default nooverflow"
                  sx={{
                    px: configEntzy.APP_SPACING_MD2X,
                    pb: configEntzy.APP_SPACING_HL,
                  }}
                >
                  <ModuleSubHeaderTag text="Spotlight Eventuators" />
                  <Box
                    className="box-default bg-black-t50 text-paragraph"
                    sx={{
                      p: configEntzy.APP_SPACING_MD,
                      borderRadius: configEntzy.BORDER_SIZE_XL,
                    }}
                  >
                    <Typography variant="h6" color="orange">
                      <a
                        href="https://entzy.com/ch/cuppaconnect"
                        target="_blank"
                        rel="noopener noreferrer"
                      >
                        <span>Cuppa Connect (Zurich, CH🇨🇭)</span>
                        <span>&nbsp;&nbsp;</span>
                        <FontAwesomeIcon icon={iconExternalLink} />
                      </a>
                    </Typography>
                    <Typography variant="subtitle2" color="orange">
                      <a
                        href="https://entzy.com/ch/cuppaconnect"
                        target="_blank"
                        rel="noopener noreferrer"
                      >
                        https://entzy.com/ch/cuppaconnect
                      </a>
                    </Typography>
                    <Typography
                      variant="subtitle2"
                      color="white"
                      sx={{ mt: configEntzy.APP_SPACING_MD }}
                    >
                      Are you ever in Zürich? Check out our coffee eventuator
                      and let's connect. Offer dates whenever you're free and
                      we'll make it happen. Join repeatedly to meet new people
                      in the area.
                    </Typography>
                  </Box>
                </Box>
              </Box>
            </Grow>

            {/* <Fade in={true} timeout={1000}>
              <Box
                className="box-default bg-black-t90 shadow-purple-glow"
                sx={{
                  mt: configEntzy.APP_SPACING_MD2X,
                  p: configEntzy.APP_SPACING_MD,
                  borderRadius: configEntzy.BORDER_SIZE_XL,
                }}
              >
                <Box
                  className="box-default"
                  sx={{
                    pt: configEntzy.APP_SPACING_LG,
                  }}
                >
                  <Typography variant="h1">
                    <FontAwesomeIcon icon={iconEventuators} size="2x" />
                  </Typography>
                </Box>
                <Box
                  className="box-default"
                  sx={{
                    pt: configEntzy.APP_SPACING_LG,
                    pb: configEntzy.APP_SPACING_LG,
                    pl: configEntzy.APP_SPACING_MD,
                    pr: configEntzy.APP_SPACING_MD,
                  }}
                >
                  <Container maxWidth="xs" disableGutters>
                    <Typography variant="h2" color="orange">
                      Entzy Eventuators.
                    </Typography>
                    <Typography
                      variant="h2"
                      color="orange"
                      sx={{
                        mt: configEntzy.APP_SPACING_SM,
                      }}
                    >
                      Runners & Riders Ready!
                    </Typography>
                    <Typography
                      variant="h6"
                      sx={{
                        mt: configEntzy.APP_SPACING_MD2X,
                      }}
                    >
                      Entzy helps fill your calendar with activities by finding
                      dates to match event runners (organizers) and event riders
                      (guests), using eventuators.
                    </Typography>
                    <Typography
                      variant="h6"
                      sx={{
                        mt: configEntzy.APP_SPACING_MD2X,
                      }}
                    >
                      Eventuators are event launchers designed to trigger
                      activity when everyone is available. Have a play as a
                      runner below with a simulation.
                    </Typography>
                    <Typography
                      variant="h6"
                      sx={{
                        mt: configEntzy.APP_SPACING_MD2X,
                      }}
                    >
                      Or if you already have a link, then join in-play activity
                      for real, as a rider.
                    </Typography>
                  </Container>
                </Box>

                <Box className="box-default half-width">
                  <Box
                    className="box-inline right"
                    sx={{
                      width: configEntzy.AVATAR_SIZE_LG,
                    }}
                  >
                    <BigButton
                      bgColor="transparent"
                      icon={showCreate ? iconClose : iconNewRunner}
                      text={showCreate ? "Close" : "Try as Runner"}
                      subText={showJoinForm ? " " : "Event Organizer"}
                      onClick={handleShowCreate}
                    />
                  </Box>
                </Box>
                <Box className="box-default half-width">
                  <Box
                    className="box-inline left"
                    sx={{
                      width: configEntzy.AVATAR_SIZE_LG,
                    }}
                  >
                    <BigButton
                      bgColor="transparent"
                      icon={showJoinForm ? iconClose : iconNewRider}
                      text={showJoinForm ? "Close" : "Join as Rider"}
                      subText={showJoinForm ? " " : "Event Guest"}
                      onClick={handleShowJoinForm}
                    />
                  </Box>
                </Box>
                <Box
                  className="box-default"
                  sx={{
                    pt: configEntzy.APP_SPACING_HL,
                    pb: configEntzy.APP_SPACING_XL,
                  }}
                >
                  <WidgetHomeMenu {...props} />
                </Box>
              </Box>
            </Fade> */}
          </Container>
          <Box className="box-default">{renderCreateForm()}</Box>
          <Box className="box-default" hidden={showCreateForm}>
            {renderJoinForm()}
          </Box>
        </Box>
      )}
      <MainCallbackLoader />
    </Box>
  );
}

export default EventList;
